import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Grid, Menu } from 'semantic-ui-react';

import * as styles from './Footer.less';

const purpleColor = { color: '#4916A9' };
const blackColor = { color: '#1a1a1a' };

const Footer = () => {
  const isMobile = window.screen.availWidth < 800;

  return (
    <Grid className={styles.footer}>
      <Grid.Row className={styles.footerMenuWrapper}>
        <Container>
          <Menu secondary className={styles.footerMenu}>
            <Menu.Menu className={styles.Menu}>
              <Menu.Item className={styles.footerItem} style={blackColor}>
                Copytesting Ltd
              </Menu.Item>
              {!isMobile && <Menu.Item style={blackColor}>|</Menu.Item>}
              <Menu.Item className={styles.footerItem} style={blackColor}>
                hello@copytesting.com
              </Menu.Item>
              {!isMobile && <Menu.Item style={blackColor}>|</Menu.Item>}
              <Menu.Item>
                <Link
                  to={`/terms`}
                  className={styles.footerItem}
                  style={purpleColor}
                >
                  Terms & Conditions
                </Link>
              </Menu.Item>
              {!isMobile && <Menu.Item style={blackColor}>|</Menu.Item>}
              <Menu.Item>
                <Link
                  to={`/privacy`}
                  className={styles.footerItem}
                  style={purpleColor}
                >
                  Privacy Policy
                </Link>
              </Menu.Item>
            </Menu.Menu>
          </Menu>
        </Container>
      </Grid.Row>
    </Grid>
  );
};

Footer.propTypes = {
  minimal: PropTypes.bool,
};

export default Footer;



// WEBPACK FOOTER //
// ./src/views/components/Footer/Footer.js